import React, { useEffect, useState } from "react";
import { Box, VStack, Circle } from "@chakra-ui/react";
import { motion, AnimatePresence } from "framer-motion";

// フェードアウトアニメーション（ページ読み込み完了時）
const fadeOutAnimation = {
  opacity: 0,
  transition: { duration: 1, ease: "easeOut" },
};

const Loading = ({ isPageLoaded }) => {
  const [showLoading, setShowLoading] = useState(true);

  useEffect(() => {
    if (isPageLoaded) {
      // 1秒後にローディングを消す
      setTimeout(() => setShowLoading(false), 1000);
    }
  }, [isPageLoaded]);

  return (
    <AnimatePresence>
      {showLoading && (
        <motion.div
          initial={{ opacity: 1 }}
          animate={isPageLoaded ? fadeOutAnimation : {}}
          exit={{ opacity: 0 }}
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            background: "rgb(241, 236, 222)",
            zIndex: 9999,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <VStack spacing={8}>
            <Box position="relative" width="100px" height="40px">
              {/* 左の円（交差） */}
              <motion.div
                style={{
                  position: "absolute",
                  top: 0,
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
                animate={{ x: [-30, 30] }}
                transition={{
                  duration: 1.5,
                  ease: "easeInOut",
                  repeat: Infinity,
                }}
              >
                <motion.div layout>
                  <Circle size="20px" bg="rgb(194, 153, 78)" />
                </motion.div>
              </motion.div>

              {/* 右の円（交差） */}
              <motion.div
                style={{
                  position: "absolute",
                  top: 0,
                  left: "50%",
                  transform: "translateX(-50%)",
                }}
                animate={{ x: [30, -30] }}
                transition={{
                  duration: 1.5,
                  ease: "easeInOut",
                  repeat: Infinity,
                }}
              >
                <motion.div layout>
                  <Circle size="20px" bg="rgb(160, 148, 62)" />
                </motion.div>
              </motion.div>
            </Box>
          </VStack>
        </motion.div>
      )}
    </AnimatePresence>
  );
};

export default Loading;
